import { SITE_IS_JBDA, SITE_IS_LB, SITE_IS_PROD } from "@/config/site.config"

export const getAssetsHygraphQLApi = () => {
  if(SITE_IS_LB)
    return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
  return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
}
export const getAuthorsHygraphQLApi = () => {
  if(SITE_IS_LB)
    return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
  return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
}
export const getGlossariesHygraphQLApi = () => {
  if(SITE_IS_LB)
    return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
  return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
}
export const getPostsHygraphQLApi = () => {
  if(SITE_IS_LB)
    return SITE_IS_PROD ? process.env.HYGRAPHQL_API : process.env.HYGRAPHQL_API
  return SITE_IS_PROD ? undefined : undefined
}